import { Portal } from "shared/ui/Portal/Portal"
import cls from "./ImageObserver.module.scss"

interface ImageObserverProps {
    image: string | undefined,
    className?: string,
    onClose?: () => void,
}

export const ImageObserver = (props: ImageObserverProps) => {
    const { image, className, onClose } = props

    return (
        <Portal>
            <div onClick={onClose} className={cls.ImageObserver}>
                <img className={cls.image} src={image} alt="fullImage"></img>
            </div>
        </Portal>
    )
}